


export interface ServiceSpecification{
    method:'post'|'put'|'delete'|'get',
    endpoint:string
}


export function GetServiceSpecification(version:string, serviceEndpointName:string):ServiceSpecification{

    const returnSpec:ServiceSpecification ={
        method: GetServiceMethod(version,serviceEndpointName),
        endpoint:GetServiceEndpoint(version,serviceEndpointName)
    }

    return returnSpec;
}

function GetServiceEndpoint(version:string, serviceEndpointName:string):string{

    switch (version) {
        case '1.0.0':
            return getEndpointValue_1_0_0(serviceEndpointName);
            break;
    
        default:
            break;
    }

    return '';

}


function GetServiceMethod(version:string, serviceEndpointName:string):'post'|'put'|'delete'|'get'{

    switch (version) {
        case '1.0.0':
            return getMethodValue_1_0_0(serviceEndpointName);
            break;
    
        default:
            break;
    }

    return 'put';

}


function getEndpointValue_1_0_0(serviceEndpointName:string):string{

    //PLATFORM
    if(serviceEndpointName === 'PLATFORM_INIT_ENDPOINT'){
        return '/api/1.0.0/platform/init';
    }

    if(serviceEndpointName === 'DELETE_PROJECT_GENERAL_KNOWLEDGE_ENDPOINT'){
        return '/api/1.0.0/training/general/knowledge/project/delete';
    }



    return '';
}

function getMethodValue_1_0_0(serviceEndpointName:string):'post'|'put'|'delete'|'get'{

    if(
        serviceEndpointName === 'PLATFORM_INIT_ENDPOINT'||

        serviceEndpointName === 'DELETE_PROJECT_GENERAL_KNOWLEDGE_ENDPOINT'
        ){
        return 'post';
    }

    if (
        serviceEndpointName === 'CROPPER_REMOVE_IMAGE_ENDPOINT'
    ) {
        return 'delete';
    }


    return 'put';
}